var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.problem)?_c('a-modal',{attrs:{"title":"","footer":null,"width":980,"destroyOnClose":true,"centered":""},model:{value:(_vm.modalVisible),callback:function ($$v) {_vm.modalVisible=$$v},expression:"modalVisible"}},[_c('OperationCard',{key:'detOffice' + -1,attrs:{"initialOffice":_vm.initialOffice,"selectedPOffice":_vm.selectedPOffice,"oneConfirmButton":true,"indice":-1,"detOffice":{
      clientId: this.problem.officeDetails.length + 1,
      office: null,
      noteField: null,
      isNew: true,
      fileList: [],
    },"problem":_vm.problem,"privilege":_vm.privilege,"noExecutorWarning":false,"structures":_vm.problem.execStructures,"required_Text":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }